import script from "./portFolio.vue?vue&type=script&setup=true&lang=js"
export * from "./portFolio.vue?vue&type=script&setup=true&lang=js"

import "./portFolio.vue?vue&type=style&index=0&id=788e6c04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-788e6c04"]])

export default __exports__